import React, { useState, useEffect } from "react";
import { Accordion, Card, useAccordionButton } from "react-bootstrap";
import { AiFillCaretDown } from "react-icons/ai";
import { useThemeColor } from "../../../hooks/useThemeColor";
import ResultItem from "./ResultItem";
import useTime from "../../../hooks/useTime";

const ContextAwareToggle = ({ children, eventKey, callback, activeKey, setActiveKey, arrow, setArrow, colorMode }) => {
    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey)
    );

    const handleClick = () => {
        const isActive = activeKey === eventKey;
        setActiveKey(isActive ? null : eventKey);
        setArrow(!isActive);
        decoratedOnClick();
    };

    return (
        <button
            type="button"
            className="px-0 py-1"
            style={{
                backgroundColor: colorMode === "dark" ? "var(--dark-gray)" : "var(--placeholder)",
                color: colorMode === "dark" ? "var(--white)" : "var(--dark)",
                border: "none",
                outline: "none",
                width: "100%",
                textAlign: "start",
                borderRadius: !arrow ? "10px" : "10px 10px 0 0"
            }}
            onClick={handleClick}
        >
            {children}
        </button>
    );
};

const ResultsAccordion = ({ item, activeKey, setActiveKey }) => {
    const { colorMode } = useThemeColor();
    const { convertDate } = useTime();
    const [arrow, setArrow] = useState(false);

    useEffect(() => {
        if (activeKey === item?.events?.[0]?.id) {
            setArrow(true);
        } else {
            setArrow(false);
        }
    }, [activeKey, item?.events?.[0]?.id]);

    return (
        <Accordion activeKey={activeKey} className={item?.events?.length ? "lottery-launcher-result" : "d-none"}>
            <Card className="my-0 py-0 w-100">
                <Card.Header className="p-0" style={{ borderBottom: colorMode === "dark" ? "2px solid transparent" : "2px solid var(--light-blue)" }}>
                    <ContextAwareToggle
                        eventKey={item?.events?.[0]?.id}
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        arrow={arrow}
                        setArrow={setArrow}
                        colorMode={colorMode}
                        className="position-relative"
                    >
                        <div className="d-flex ps-2 accordion-font">
                            {/* <div className="">
                                <img className="" src={rootUrl + item?.game?.game_icon} alt="lottery-item" width={"20"} height={"20"} style={{ borderRadius: "50%", }} />
                            </div> */}
                            <div className="ps-2 pe-5">
                                <span className="fw-bold" style={{ color: colorMode === "dark" ? "var(--white)" : "var(--dark)" }}>
                                    {convertDate(item?.events?.[0]?.start_time) + " - "}
                                </span>
                                <span className="fw-bold" style={{ color: colorMode === "dark" ? "var(--white)" : "var(--dark)" }}>
                                    {item?.name || "N/A"}
                                </span>
                                <span
                                    className="position-absolute"
                                    style={{
                                        right: 20,
                                        top: 6,
                                        transform: arrow ? "rotate(180deg)" : "rotate(360deg)",
                                        transitionDuration: "0.7s"
                                    }}
                                >
                                    <AiFillCaretDown fill={colorMode === "dark" ? "var(--white)" : "var(--dark)"} />
                                </span>
                            </div>
                        </div>
                    </ContextAwareToggle>
                </Card.Header>
                <Accordion.Collapse eventKey={item?.events?.[0]?.id}>
                    <Card.Body className="p-0 m-0">
                        <ResultItem gameItem={item} arrow={arrow} />
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    );
};

export default ResultsAccordion;